import { render, staticRenderFns } from "./submit.vue?vue&type=template&id=ca80c7ea&scoped=true"
import script from "./submit.vue?vue&type=script&lang=js"
export * from "./submit.vue?vue&type=script&lang=js"
import style0 from "./submit.vue?vue&type=style&index=0&id=ca80c7ea&prod&scoped=true&lang=less"
import style1 from "./submit.vue?vue&type=style&index=1&id=ca80c7ea&prod&lang=css"
import style2 from "./submit.vue?vue&type=style&index=2&id=ca80c7ea&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca80c7ea",
  null
  
)

export default component.exports